import {
  BackArrowButton,
  CancelButton,
  CloseButton,
  FinishButton,
} from "../../fixedassetelements/button/Button";

import commonstyles from "../../css/Forms.module.css";
import styles from "../../css/Uploadedfile.module.css";
import ExcelFile from "../../assets/icons/Excel File.png";
import addIcon from "../../assets/icons/addEcl.svg";
import removeIcon from "../../assets/icons/removeLoansIcons.svg";
import refreshIcon from "../../assets/icons/repeatIcon.svg";
import Success from "../../assets/icons/circle_check.svg";

function ReceivablesUploadedFile({
  uploadedFiles = [],
  handleRemoveFile,
  onRefreshMapping,
  onStartMapping,
  onFinish,
  onBack,
  onClose,
  onAdd,
   onNavigateToUpload,
}) {
  const files = uploadedFiles ?? [];


  const handleBackClick=()=>{
    if(onNavigateToUpload){
      onNavigateToUpload();
    }else if(onBack){
      onBack();
    }

    
  }
  return (
    <div className={commonstyles.backdrop}>
      <div className={`${commonstyles.container} ${styles.smallContainer}`}>
        
        
        <div className={`${commonstyles.header} ${commonstyles.headerLarge}`}>
          <div className={commonstyles.headerLeft}>
            <BackArrowButton onClick={handleBackClick} />
            <h2 className={commonstyles.heading}>
              Receivable Register – Uploaded Files
            </h2>
          </div>
          <CloseButton onClick={onClose} />
        </div>

        <div className={styles.contentWrapper}>
         <div className={styles.upperText}>
          <h5 className={styles.filesUpload}>{files.length} file(s) uploaded</h5>

          <button className={styles.addButton} onClick={onAdd}>
            <img src={addIcon} alt="add" />
            Add Files
          </button>
         </div>

        <div className={styles.fileList}>
          {files.map((file, index) => (
            <div className={styles.fileRow} key={index}>
              
              
              <div className={styles.leftSide}>
                <img src={ExcelFile} alt="excelfile" className={styles.excelfileImg}/>
                <span className={styles.fileName}>{file.name}</span>

                <button
                  className={styles.removeBtn}
                  onClick={() => handleRemoveFile?.(index)}
                >
                  <img src={removeIcon} alt="remove" />
                </button>
              </div>

          
              <div className={styles.mappingRight}>
                {file.mapped ? (
                 <div className={styles.mappedRow}>
                    <img src={Success} alt="success" className={styles.successBtn}/>
                    <span className={styles.mappedText}>Mapped</span>
                     <button className={styles.refreshBtn}  onClick={() => onRefreshMapping(index)}>
                     <img src={refreshIcon} alt="refresh" />
                     </button>
                  </div>
                ) : (
                  <button
                    className={styles.startMapping}
                    onClick={() => onStartMapping(index)}
                  >
                    Start Mapping
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
       </div>

       
        <div className={styles.footer}>
          <CancelButton onClick={onClose} />
          <FinishButton onClick={onFinish} />
        </div>
      </div>
    </div>
  );
}

export default ReceivablesUploadedFile;
